import { machineCatalogueActions } from "../../constants/actionTypes";

const setSelectedTab = (data) => ({
  type: machineCatalogueActions.SELECTED_TAB,
  payload: data,
});

const catalogueBulkUploadRequest = (data) => ({
  type: machineCatalogueActions.CATALOG_BULK_UPLOAD_REQUEST,
  data: data,
});

const catalogueBulkUploadSuccess = (data) => ({
  type: machineCatalogueActions.CATALOG_BULK_UPLOAD_SUCCESS,
  data: data,
});

const catalogueBulkUploadError = (data) => ({
  type: machineCatalogueActions.CATALOG_BULK_UPLOAD_ERROR,
  data: data,
});

const getSkusListData = (data) => ({
  type: machineCatalogueActions.SKUSLISTGETDATA,
  payload: data,
});

const setSkusListData = (data) => ({
  type: machineCatalogueActions.SKUSLISTSETDATA,
  payload: data,
});

const setSkusListError = (data) => ({
  type: machineCatalogueActions.SKUSLISTSETERROR,
  payload: data,
});

const catalogCreateRequest = (data) => ({
  type: machineCatalogueActions.CREATE_CATALOG_REQUEST,
  payload: data,
});

const setCatalogCreateSuccess = (data) => ({
  type: machineCatalogueActions.CATALOG_CREATE_SUCCESS,
  data: data,
});

const setCatalogCreateError = (data) => ({
  type: machineCatalogueActions.CATALOG_CREATE_ERROR,
  data: data,
});

const catalogEditRequest = (data) => ({
  type: machineCatalogueActions.EDIT_CATALOG_REQUEST,
  payload: data,
});

const setCatalogEditSuccess = (data) => ({
  type: machineCatalogueActions.EDIT_CATALOG_SUCCESS,
  payload: data,
});

const setCatalogEditError = (data) => ({
  type: machineCatalogueActions.EDIT_CATALOG_ERROR,
  data: data,
});

const removeSkuRequest = (data) => ({
  type: machineCatalogueActions.REMOVE_SKU_REQUEST,
  payload: data,
});

const removeSkuSuccess = (data) => ({
  type: machineCatalogueActions.REMOVE_SKU_SUCCESS,
  payload: data,
});

const removeSkuError = (data) => ({
  type: machineCatalogueActions.REMOVE_SKU_ERROR,
  payload: data,
});

const addSkuRequest = (data) => ({
  type: machineCatalogueActions.ADD_SKU_REQUEST,
  payload: data,
});

const addSkuSuccess = (data) => ({
  type: machineCatalogueActions.ADD_SKU_SUCCESS,
  payload: data,
});

const addSkuError = (data) => ({
  type: machineCatalogueActions.ADD_SKU_ERROR,
  payload: data,
});

const retireSkuRequest = (data) => ({
  type: machineCatalogueActions.RETIRE_SKU_REQUEST,
  payload: data,
});

const retireSkuSuccess = (data) => ({
  type: machineCatalogueActions.RETIRE_SKU_SUCCESS,
  payload: data,
});

const retireSkuError = (data) => ({
  type: machineCatalogueActions.RETIRE_SKU_ERROR,
  payload: data,
});

const deleteCloudTemplateById = (data) => ({
  type: machineCatalogueActions.DELETE_CLOUD_TEMPLATE,
  payload: data,
});

const deleteCloudTemplateByIdSuccess = (data) => ({
  type: machineCatalogueActions.DELETE_CLOUD_TEMPLATE_SUCCESS,
  payload: data,
});

const deleteCloudTemplateByIdError = (data) => ({
  type: machineCatalogueActions.DELETE_CLOUD_TEMPLATE_ERROR,
  payload: data,
});

const getCloudTemplates = (data) => ({
  type: machineCatalogueActions.FETCH_CLOUD_TEMPLATES,
  payload: data,
});

const setCloudTemplates = (data) => ({
  type: machineCatalogueActions.FETCH_CLOUD_TEMPLATES_SUCCESS,
  payload: data,
});
const setCloudTemplatesError = (data) => ({
  type: machineCatalogueActions.FETCH_CLOUD_TEMPLATES_ERROR,
  payload: data,
});

const getCloudTemplateById = (data) => ({
  type: machineCatalogueActions.FETCH_CLOUD_TEMPLATE_BY_ID,
  payload: data,
});

const setCloudTemplateById = (data) => ({
  type: machineCatalogueActions.FETCH_CLOUD_TEMPLATE_BY_ID_SUCCESS,
  payload: data,
});
const setCloudTemplateByIdError = (data) => ({
  type: machineCatalogueActions.FETCH_CLOUD_TEMPLATE_BY_ID_ERROR,
  payload: data,
});

const createCloudBatch = (data) => ({
  type: machineCatalogueActions.CREATE_CLOUD_BATCH,
  payload: data,
});

const editCloudBatch = (data) => ({
  type: machineCatalogueActions.EDIT_CLOUD_BATCH,
  payload: data,
});

const patchCloudBatch = (data) => ({
  type: machineCatalogueActions.PATCH_CLOUD_BATCH,
  payload: data,
});

const createCloudBatchSuccess = (data) => ({
  type: machineCatalogueActions.CREATE_CLOUD_BATCH_SUCCESS,
  payload: data,
});
const createCloudBatchError = (data) => ({
  type: machineCatalogueActions.CREATE_CLOUD_BATCH_ERROR,
  payload: data,
});

const deleteCloudBatch = (data) => ({
  type: machineCatalogueActions.DELETE_CLOUD_BATCH,
  payload: data,
});

const deleteCloudBatchSuccess = (data) => ({
  type: machineCatalogueActions.DELETE_CLOUD_BATCH_SUCCESS,
  payload: data,
});

const deleteCloudBatchError = (data) => ({
  type: machineCatalogueActions.DELETE_CLOUD_BATCH_ERROR,
  payload: data,
});

const deleteCloudLabSuccess = (data) => ({
  type: machineCatalogueActions.DELETE_CLOUD_LAB_SUCCESS,
  payload: data,
});

const getCloudBatchById = (data) => ({
  type: machineCatalogueActions.FETCH_CLOUD_BATCH_BY_ID,
  payload: data,
});
const getCloudBatchByIdSuccess = (data) => ({
  type: machineCatalogueActions.FETCH_CLOUD_BATCH_BY_ID_SUCCESS,
  payload: data,
});
const getCloudBatchByIdError = (data) => ({
  type: machineCatalogueActions.FETCH_CLOUD_BATCH_BY_ID_ERROR,
  payload: data,
});

const getWorkspaceCloudBatchById = (data) => ({
  type: machineCatalogueActions.FETCH_WORKSPACE_CLOUD_BATCH_BY_ID,
  payload: data,
});
const getWorkspaceCloudBatchByIdSuccess = (data) => ({
  type: machineCatalogueActions.FETCH_WORKSPACE_CLOUD_BATCH_BY_ID_SUCCESS,
  payload: data,
});
const getWorkspaceCloudBatchByIdError = (data) => ({
  type: machineCatalogueActions.FETCH_WORKSPACE_CLOUD_BATCH_BY_ID_ERROR,
  payload: data,
});

const resetCloudBatchList = () => ({
  type: machineCatalogueActions.RESET_CLOUD_BATCH_LIST,
  payload: {},
});

const getCloudBatches = (data) => ({
  type: machineCatalogueActions.LIST_CLOUD_BATCH,
  payload: data,
});

const getCloudBatchesSuccess = (data) => ({
  type: machineCatalogueActions.LIST_CLOUD_BATCH_SUCCESS,
  payload: data,
});

const getCloudBatchesError = (data) => ({
  type: machineCatalogueActions.LIST_CLOUD_BATCH_ERROR,
  payload: data,
});

const getWorkspaceCloudBatches = (data) => ({
  type: machineCatalogueActions.LIST_WORKSPACE_CLOUD_BATCH,
  payload: data,
});

const getWorkspaceCloudBatchesSuccess = (data) => ({
  type: machineCatalogueActions.LIST_WORKSPACE_CLOUD_BATCH_SUCCESS,
  payload: data,
});

const getWorkspaceCloudBatchesError = (data) => ({
  type: machineCatalogueActions.LIST_WORKSPACE_CLOUD_BATCH_ERROR,
  payload: data,
});

const getWorkspaceCloudBatchesReports = (data) => ({
  type: machineCatalogueActions.GET_WORKSPACE_BATCH_REPORTS_LIST,
  payload: data,
});

const setWorkspaceCloudBatchesReportsSuccess = (data) => ({
  type: machineCatalogueActions.SET_WORKSPACE_BATCH_REPORTS_LIST_SUCCESS,
  payload: data,
});

const setWorkspaceCloudBatchesReportsError = (data) => ({
  type: machineCatalogueActions.SET_WORKSPACE_BATCH_REPORTS_LIST_ERROR,
  payload: data,
});

const resetWorkspaceCloudBatchesReports = () => ({
  type: machineCatalogueActions.RESET_WORKSPACE_BATCH_REPORTS_LIST,
});

const getWorkspacesTenantList = (data) => ({
  type: machineCatalogueActions.GET_WORKSPACE_TENANT_LIST,
  payload: data,
});

const setWorkspacesTenantList = (data) => ({
  type: machineCatalogueActions.SET_WORKSPACE_TENANT_LIST_SUCCESS,
  payload: data,
});

const getWorkspacesByTenantId = (data) => ({
  type: machineCatalogueActions.GET_WORKSPACES_LIST,
  payload: data,
});

const setWorkspacesByTenantIdSuccess = (data) => ({
  type: machineCatalogueActions.SET_WORKSPACES_LIST_SUCCESS,
  payload: data,
});

const generateWorkspaceReport = (data) => ({
  type: machineCatalogueActions.GENERATE_WORKSPACE_BATCH_REPORT,
  payload: data,
});

const generateWorkspaceReportSuccess = (data) => ({
  type: machineCatalogueActions.GENERATE_WORKSPACE_BATCH_REPORT_SUCCESS,
  payload: data,
});
const generateWorkspaceReportError = (data) => ({
  type: machineCatalogueActions.GENERATE_WORKSPACE_BATCH_REPORT_ERROR,
  payload: data,
});

const resetWorkspaceBatchReportForm = () => ({
  type: machineCatalogueActions.RESET_WORKSPACE_BATCH_REPORTS_FORM,
});

const createCloudLab = (data) => ({
  type: machineCatalogueActions.CREATE_CLOUD_LAB,
  payload: data,
});

const createCloudLabSuccess = (data) => ({
  type: machineCatalogueActions.CREATE_CLOUD_LAB_SUCCESS,
  payload: data,
});
const createCloudLabError = (data) => ({
  type: machineCatalogueActions.CREATE_CLOUD_LAB_ERROR,
  payload: data,
});

const deleteCloudLab = (data) => ({
  type: machineCatalogueActions.DELETE_CLOUD_LAB,
  payload: data,
});

const getCloudLabs = (data) => ({
  type: machineCatalogueActions.LIST_CLOUD_LAB,
  payload: data,
});

const getCloudLabById = (data) => ({
  type: machineCatalogueActions.FETCH_CLOUD_LAB_BY_ID,
  payload: data,
});
const getCloudLabByIdSuccess = (data) => ({
  type: machineCatalogueActions.FETCH_CLOUD_LAB_BY_ID_SUCCESS,
  payload: data,
});
const getCloudLabByIdError = (data) => ({
  type: machineCatalogueActions.FETCH_CLOUD_LAB_BY_ID_ERROR,
  payload: data,
});

const getCloudLabSuccess = (data) => ({
  type: machineCatalogueActions.LIST_CLOUD_LAB_SUCCESS,
  payload: data,
});

const getCloudLabError = (data) => ({
  type: machineCatalogueActions.LIST_CLOUD_LAB_ERROR,
  payload: data,
});

const createCloudLabExtension = (data) => ({
  type: machineCatalogueActions.CREATE_CLOUD_LAB_EXTENISION,
  payload: data,
});

const createCloudLabExtensionSuccess = (data) => ({
  type: machineCatalogueActions.CREATE_CLOUD_LAB_EXTENISION_SUCCESS,
  payload: data,
});

const createCloudBatchExtension = (data) => ({
  type: machineCatalogueActions.CREATE_CLOUD_BATCH_EXTENISION,
  payload: data,
});
const createCloudLabExtensionError = (data) => ({
  type: machineCatalogueActions.CREATE_CLOUD_LAB_EXTENISION_ERROR,
  payload: data,
});

const patchCloudLabFeedback = (data) => ({
  type: machineCatalogueActions.PATCH_CLOUD_LAB_FEEDBACK,
  payload: data,
});

const deleteCloudLabFeedback = (data) => ({
  type: machineCatalogueActions.DELETE_CLOUD_LAB_FEEDBACK,
  payload: data,
});

const getCloudLabFeedbackById = (data) => ({
  type: machineCatalogueActions.FETCH_CLOUD_LAB_FEEDBACK_BY_ID,
  payload: data,
});

const getCloudLabFeedbackList = (data) => ({
  type: machineCatalogueActions.LIST_CLOUD_LAB_FEEDBACK,
  payload: data,
});

const setBatchLoading = (data) => ({
  type: machineCatalogueActions.SET_BATCH_LOADING,
  payload: data,
});

const setTemplateDetailsLoading = (data) => ({
  type: machineCatalogueActions.SET_TEMPLATE_DETAILS_LOADING,
  payload: data,
});

const setLabLoading = (data) => ({
  type: machineCatalogueActions.SET_LAB_LOADING,
  payload: data,
});

const setLabDetailsLoading = (data) => ({
  type: machineCatalogueActions.SET_LAB_DETAILS_LOADING,
  payload: data,
});

const setBatchDetailsLoading = (data) => ({
  type: machineCatalogueActions.SET_BATCH_DETAILS_LOADING,
  payload: data,
});

const setLinkTenantListLoading = (data) => ({
  type: machineCatalogueActions.SET_LINK_TENANT_LIST_LOADING,
  payload: data,
});
const setLinkTenantLoading = (data) => ({
  type: machineCatalogueActions.SET_LINK_TENANT_LOADING,
  payload: data,
});
const getLinkTenantList = (data) => ({
  type: machineCatalogueActions.LIST_LINK_TENANT,
  payload: data,
});

const getLinkTenantListSuccess = (data) => ({
  type: machineCatalogueActions.LIST_LINK_TENANT_SUCCESS,
  payload: data,
});

const deleteLinkedTenant = (data) => ({
  type: machineCatalogueActions.DELETE_LINK_TENANT,
  payload: data,
});
const deleteLinkedTenantSuccess = (data) => ({
  type: machineCatalogueActions.DELETE_LINK_TENANT_SUCCESS,
  payload: data,
});

const editLinkedTenant = (data) => ({
  type: machineCatalogueActions.EDIT_LINK_TENANT,
  payload: data,
});
const createLinkedTenant = (data) => ({
  type: machineCatalogueActions.CREATE_LINK_TENANT,
  payload: data,
});
const createLinkedTenantSuccess = (data) => ({
  type: machineCatalogueActions.CREATE_LINK_TENANT_SUCCESS,
  payload: data,
});
const createLinkedTenantError = (data) => ({
  type: machineCatalogueActions.CREATE_LINK_TENANT_ERROR,
  payload: data,
});

const retrieveByIdLinkedTenant = (data) => ({
  type: machineCatalogueActions.RETRIEVE_BY_ID_LINK_TENANT,
  payload: data,
});
const retrieveByIdLinkedTenantSuccess = (data) => ({
  type: machineCatalogueActions.RETRIEVE_BY_ID_LINK_TENANT_SUCCESS,
  payload: data,
});

const requestCloudLabCredential = (data) => ({
  type: machineCatalogueActions.REQUEST_CLOUD_LAB_CREDENTIAL,
  payload: data,
});

const successCloudLabCredential = (data) => ({
  type: machineCatalogueActions.SUCCESS_CLOUD_LAB_CREDENTIAL,
  payload: data,
});

const errorCloudLabCredential = (data) => ({
  type: machineCatalogueActions.ERROR_CLOUD_LAB_CREDENTIAL,
  payload: data,
});

const setCloudCred = (data) => ({
  type: machineCatalogueActions.SET_CLOUD_CREDENTIALS,
  payload: data,
});

const updatePermissionPolicy = (id, data) => ({
  type: machineCatalogueActions.UPDATE_PERMISSION_POLICY,
  id,
  payload: data,
});

const setUpdatePermissionPolicySuccess = (data) => ({
  type: machineCatalogueActions.UPDATE_PERMISSION_POLICY_SUCCESS,
  payload: data,
});

const setUpdatePermissionPolicyError = (data) => ({
  type: machineCatalogueActions.UPDATE_PERMISSION_POLICY_ERROR,
  payload: data,
});

const cloudLabReProvision = (data) => ({
  type: machineCatalogueActions.CLOUD_LAB_RE_PROVISION,
  payload: data,
});

const setCloudLabReProvisionSuccess = (data) => ({
  type: machineCatalogueActions.CLOUD_LAB_RE_PROVISION_SUCCESS,
  payload: data,
});

const setCloudLabReProvisionError = (data) => ({
  type: machineCatalogueActions.CLOUD_LAB_RE_PROVISION_ERROR,
  payload: data,
});

// Azure Report Download
const azureReportDownloadLoading = (data) => ({
  type: machineCatalogueActions.AZURE_REPORT_DOWNLOAD_LOADING,
  payload: data,
});
const azureReportDownloadAction = (data) => ({
  type: machineCatalogueActions.AZURE_REPORT_DOWNLOAD_ACTION,
  payload: data,
});
const azureReportDownloadSuccess = (data) => ({
  type: machineCatalogueActions.AZURE_REPORT_DOWNLOAD_SUCCESS,
  payload: data,
});
const azureReportDownloadError = (data) => ({
  type: machineCatalogueActions.AZURE_REPORT_DOWNLOAD_ERROR,
  payload: data,
});
const azureReportDownloadReset = (data) => ({
  type: machineCatalogueActions.AZURE_REPORT_DOWNLOAD_RESET,
  payload: data,
});

// Clean Up Azure
const cleanUpAzureLoading = (payload) => ({
  type: machineCatalogueActions.CLEAN_UP_AZURE_LOADING,
  payload: payload,
});
const cleanUpAzureAction = (payload) => ({
  type: machineCatalogueActions.CLEAN_UP_AZURE_ACTION,
  payload: payload,
});
const cleanUpAzureSuccess = (payload) => ({
  type: machineCatalogueActions.CLEAN_UP_AZURE_SUCCESS,
  payload: payload,
});
const cleanUpAzureError = (payload) => ({
  type: machineCatalogueActions.CLEAN_UP_AZURE_ERROR,
  payload: payload,
});
const cleanUpAzureReset = () => ({
  type: machineCatalogueActions.CLEAN_UP_AZURE_RESET,
});

const syncBillAction = (data) => ({
  type: machineCatalogueActions.SYNC_BILL_ACTION,
  payload: data,
});

const syncBillSuccess = (data) => ({
  type: machineCatalogueActions.SYNC_BILL_SUCCESS,
  payload: data,
});

const syncBillError = (data) => ({
  type: machineCatalogueActions.SYNC_BILL_ERROR,
  payload: data,
});

const aws_cleanup_loading = (payload) => ({
  type: machineCatalogueActions.AWS_CLEANUP_LOADING,
  payload: payload,
});

const aws_cleanup_action = (payload) => ({
  type: machineCatalogueActions.AWS_CLEANUP_ACTION,
  payload: payload,
});

const aws_cleanup_success = (payload) => ({
  type: machineCatalogueActions.AWS_CLEANUP_SUCCESS,
  payload: payload,
});

const aws_cleanup_error = (payload) => ({
  type: machineCatalogueActions.AWS_CLEANUP_ERROR,
  payload: payload,
});

const aws_cleanup_reset = () => ({
  type: machineCatalogueActions.AWS_CLEANUP_RESET,
});

const getMentorList = (payload) => ({
  type: machineCatalogueActions.GET_MENTOR_LIST,
  payload,
});

const getMentorListSuccess = (payload) => ({
  type: machineCatalogueActions.GET_MENTOR_LIST_SUCCESS,
  payload,
});

const getMentorListFail = (payload) => ({
  type: machineCatalogueActions.GET_MENTOR_LIST_ERROR,
  payload,
});

const resetMentorList = () => ({
  type: machineCatalogueActions.RESET_MENTOR_LIST,
});

export {
  setSelectedTab,
  retrieveByIdLinkedTenantSuccess,
  retrieveByIdLinkedTenant,
  setLinkTenantLoading,
  createLinkedTenantSuccess,
  createLinkedTenant,
  editLinkedTenant,
  deleteLinkedTenantSuccess,
  deleteLinkedTenant,
  getLinkTenantList,
  setLinkTenantListLoading,
  getLinkTenantListSuccess,
  getSkusListData,
  setSkusListData,
  setSkusListError,
  catalogCreateRequest,
  setCatalogCreateSuccess,
  setCatalogCreateError,
  catalogEditRequest,
  setCatalogEditSuccess,
  setCatalogEditError,
  catalogueBulkUploadRequest,
  catalogueBulkUploadSuccess,
  catalogueBulkUploadError,
  removeSkuRequest,
  removeSkuSuccess,
  removeSkuError,
  addSkuRequest,
  addSkuSuccess,
  addSkuError,
  retireSkuRequest,
  retireSkuSuccess,
  retireSkuError,
  getCloudTemplates,
  getCloudTemplateById,
  setCloudTemplateById,
  createCloudBatch,
  editCloudBatch,
  deleteCloudBatch,
  getCloudBatchById,
  resetCloudBatchList,
  getCloudBatches,
  createCloudLab,
  deleteCloudLab,
  getCloudLabs,
  getCloudLabById,
  createCloudLabExtension,
  patchCloudLabFeedback,
  deleteCloudLabFeedback,
  getCloudLabFeedbackList,
  getCloudLabFeedbackById,
  setCloudTemplates,
  setCloudTemplatesError,
  setCloudTemplateByIdError,
  createCloudBatchSuccess,
  createCloudBatchError,
  getCloudBatchesError,
  getCloudBatchesSuccess,
  getCloudLabError,
  getCloudLabSuccess,
  getCloudBatchByIdError,
  getCloudBatchByIdSuccess,
  getCloudLabByIdError,
  getWorkspaceCloudBatchById,
  getWorkspaceCloudBatchByIdSuccess,
  getWorkspaceCloudBatchByIdError,
  getWorkspaceCloudBatches,
  getWorkspaceCloudBatchesSuccess,
  getWorkspaceCloudBatchesError,
  getCloudLabByIdSuccess,
  setBatchLoading,
  setBatchDetailsLoading,
  deleteCloudBatchError,
  deleteCloudBatchSuccess,
  setLabDetailsLoading,
  setLabLoading,
  setTemplateDetailsLoading,
  createCloudLabSuccess,
  createCloudLabError,
  patchCloudBatch,
  createCloudLabExtensionError,
  createCloudLabExtensionSuccess,
  createCloudBatchExtension,
  deleteCloudTemplateById,
  deleteCloudTemplateByIdSuccess,
  requestCloudLabCredential,
  successCloudLabCredential,
  errorCloudLabCredential,
  createLinkedTenantError,
  deleteCloudLabSuccess,
  deleteCloudTemplateByIdError,
  setCloudCred,
  updatePermissionPolicy,
  setUpdatePermissionPolicySuccess,
  setUpdatePermissionPolicyError,
  cloudLabReProvision,
  setCloudLabReProvisionSuccess,
  setCloudLabReProvisionError,
  getWorkspaceCloudBatchesReports,
  setWorkspaceCloudBatchesReportsSuccess,
  setWorkspaceCloudBatchesReportsError,
  resetWorkspaceCloudBatchesReports,
  getWorkspacesTenantList,
  setWorkspacesTenantList,
  getWorkspacesByTenantId,
  setWorkspacesByTenantIdSuccess,
  generateWorkspaceReport,
  generateWorkspaceReportSuccess,
  generateWorkspaceReportError,
  resetWorkspaceBatchReportForm,
  azureReportDownloadLoading,
  azureReportDownloadAction,
  azureReportDownloadSuccess,
  azureReportDownloadError,
  azureReportDownloadReset,
  cleanUpAzureLoading,
  cleanUpAzureAction,
  cleanUpAzureSuccess,
  cleanUpAzureError,
  cleanUpAzureReset,
  syncBillAction,
  syncBillSuccess,
  syncBillError,
  aws_cleanup_loading,
  aws_cleanup_action,
  aws_cleanup_success,
  aws_cleanup_error,
  aws_cleanup_reset,
  getMentorList,
  getMentorListSuccess,
  getMentorListFail,
  resetMentorList,
};
